var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortingaz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-873 -588) translate(873 588)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#32325D",
    strokeLinecap: "square",
    strokeWidth: 1.333,
    d: "M7.926 13.296L4.963 10.333 2 13.296",
    transform: "translate(-873 -588) translate(873 588) matrix(1 0 0 -1 0 23.63)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#32325D",
    strokeLinecap: "square",
    strokeWidth: 1.333,
    d: "M4.963 3L4.963 12.111",
    transform: "translate(-873 -588) translate(873 588) matrix(1 0 0 -1 0 15.111)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    fillRule: "nonzero",
    d: "M13.755 13.705h-2.17l2.32-3.585c.057-.074.057-.124.057-.199v-.597c0-.2-.094-.324-.245-.324H10.34c-.151 0-.246.124-.246.324v.647c0 .2.095.324.246.324h2.037l-2.32 3.61c-.057.074-.057.124-.057.199v.572c0 .2.094.324.245.324h3.51c.15 0 .245-.124.245-.324v-.622c0-.174-.094-.349-.245-.349zM14.97 6.548l-2.107-5.347c-.07-.126-.142-.201-.26-.201h-1.137c-.118 0-.237.075-.26.2L9.027 6.549c-.094.226.071.452.26.452h.877c.118 0 .237-.1.26-.2l.332-.854h2.439l.308.853c.023.126.142.201.26.201h.9c.26-.05.402-.276.308-.452zM11 5l1-2 1 2h-2z",
    transform: "translate(-873 -588) translate(873 588)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingaz);
export default __webpack_public_path__ + "static/media/sortingaz.8ec2efacb444647913507ea8dc928b70.svg";
export { ForwardRef as ReactComponent };